import React from 'react';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { GenericModalTypes } from './GenericModalWithIconContentTypes';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { MediumCheckIcon, MediumExclamationIcon } from '../Icons';
export var GenericModalWithIconContent = function (_a) {
    var buttons = _a.buttons, children = _a.children, mainText = _a.mainText, type = _a.type, dataTestId = _a.dataTestId, onClose = _a.onClose, titleText = _a.titleText;
    var t = useTranslation().t;
    return (React.createElement(ModalContent, { buttons: buttons, dataTestId: dataTestId || 'GenericModalWithIconContent', titleText: titleText || '', closeButtonAltText: t('shift_management_common_closeModalButton'), onCloseButtonClick: onClose },
        React.createElement(View, { margin: { top: 'S500' } },
            React.createElement(IconTitleWrapper, { hasChildren: !!children },
                type === GenericModalTypes.success ? (React.createElement(MediumCheckIcon, { title: "Success Icon", dataTestId: "GenericModalIcon_Success", color: "green70" })) : (React.createElement(MediumExclamationIcon, { title: "Danger Icon", dataTestId: "GenericModalIcon_Danger", color: "red70" })),
                React.createElement(MainText, { fontSize: "T500" }, mainText)),
            children)));
};
var IconTitleWrapper = styledWithTheme(View)(function (_a) {
    var hasChildren = _a.hasChildren, theme = _a.theme;
    return "\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    ".concat(hasChildren &&
        "\n        margin-bottom: ".concat(theme.selectors.space('S200'), "px;\n    "), "\n  ");
});
var MainText = styledWithTheme(Text)(function (_a) {
    var theme = _a.theme;
    return "\n    margin-top: ".concat(theme.selectors.space('S200'), "px;\n");
});
